import CustomCheckbox from 'components/custom-checkbox/custom-checkbox.component';
import { useDisplayInfo } from 'hooks/useDisplayInfo';
import React, { useContext } from 'react';
import { Stack } from '@mui/material';
import OptionItemLabel from '../option-item-label/option-item-label.component';
import { useOptionItemCheckbox } from './option-item-checkbox.hooks';
import { convertCentsToDollar } from 'utils';
import MenuDialogContext from 'hooks/dialog/menu-dialog.context';
import Calories from 'pages/menu/menu-modal/calories/calories.component';

const OptionItemCheckbox = props => {
  const { item, isItemOutOfStock } = props;
  const { price, displayInfo, lockedModifier } = item;
  const { title, smallImage } = useDisplayInfo(displayInfo);
  const { checked, handleCheckboxChange, isDisableModifierGroup } =
    useOptionItemCheckbox(props);
  const { catalog } = useContext(MenuDialogContext);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <CustomCheckbox
        checked={checked}
        onChange={handleCheckboxChange}
        disabled={isDisableModifierGroup || lockedModifier || isItemOutOfStock}
        label={
          <OptionItemLabel
            isItemOutOfStock={isItemOutOfStock}
            title={title}
            price={price}
            smallImage={smallImage}
          />
        }
        dataTestId="OptionItem"
        inputProps={{
          'aria-label': `${title} ${
            price !== 0 ? `- ${convertCentsToDollar(price)}` : ''
          }`,
        }}
      />
      <Calories
        catalogExtendedAttributes={catalog?.extendedAttributes}
        calories={item.calories}
      />
    </Stack>
  );
};

export default OptionItemCheckbox;
